export default {
  search: "SEARCH",
  clear: "CLEAR",
  close: "CLOSE",
  clear_:'CLEAR',
  search_result:'SEARCH RESULT',
  no_result: "NO RESULT.",
  load_more: 'more',
  required: "REQUIRED",
  optional: "OPTIONAL",
  detail: "DETAIL",
  sku_detail: "SKU DETAIL",
  verification_of_phone: "VERIFICATION OF PHONE",
  verification_of_email: "VERIFICATION OF EMAIL",
  change_password: "CHANGE PASSWORD",
  forget_pwd: "FORGET PASSWORD",
  set_pwd: "SET PASSWORD",
  next: "NEXT",
  training:"TRAINING",
  training_new:"NEW USERS ONBOARDING",
  training_old:"NEW FUNCTION ONBOARDING",
  "产品库":'ASSET CENTER',
  attend_sport:'SCAN TO JOIN SPORT',
  PAL: "PRODUCT ASSET LIBRARY",
  check_all: "CHECK ALL",
  deselect_all:"DESELECT ALL",
  preferences: "PREFERENCES",
  event_tag: "ADMIN TAGS",
  interest_tag:"INTEREST TAGS",
  gender: "GENDER",
  category: "CATEGORY",
  division: "DIVISION",
  finish:"FINISH",
  planning_intended_use: "PLANNING INTENDED USE",
  content_of_interest: "CONTENT OF INTEREST",
  description:"DESCRIPTION",
  autoClose: "IT SHUTS DOWN AUTOMATICALLY AFTER {seconds} SECONDS",
  keep_open: "KEEP OPEN",
  training_description:{
    "page1": "PERSONAL CENTER",
    "page2": "Maintain personal information",
    "page3": "SAVE PERSONAL INFORMATION",
    "page4": "PLAZA IS INCLUDES ANNOUNCEMENTS AND SPORTS",
    "page5": "ANNOUNCEMENT",
    "page6": "ANNOUNCEMENT DETAILS",
    "page7": "SPORTS",
    "page8": "SCAN THE QR CODE ON YOUR PHONE TO REGISTER FOR SPORTS ACTIVITY",
    "page9": "EMOMENT HELP DESK",
    "page10": "EMOMENT USER MANUAL, NEW FEATURE INTRODUCTION VIDEO, FAQ",
    "page11": "USER MANUAL",
    "page12": "USER MANUAL",
    "page13": "NEW FEATURE INTRODUCTION VIDEO",
    "page14": "NEW FEATURE INTRODUCTION VIDEO",
    "page15": "FAQ",
    "page16": "FAQ",
    "page17": "CLOSE EMOMENT HELP DESK",
    "page18": "ENTER EVENT",
    "page19": "SESSION",
    "page20": "SESSION TYPE IS LIVE, AND A GREEN DOT IS DISPLAYED IN THE BOTTOM RIGHT CORNER, INDICATING THAT THE LIVE SESSION IS IN PROGRESS",
    "page21": "SESSION TOOLS, INCLUDING VSS,CHAT ROOMS, BOOKMARKS, PRODUCT PUSH, ETC",
    "page22": "RETURN TO SESSION LIST",
    "page23": "SESSION TYPE IS ZOOM, AND A GREEN DOT IS DISPLAYED IN THE BOTTOM RIGHT CORNER, INDICATING THAT THE ZOOM SESSION IS IN PROGRESS",
    "page24": "CLICK TO ENTER ZOOM",
    "page25": "RETURN TO SESSION LIST",
    "page26": "THE SESSION TYPE IS PLAYBACK, AND THE BUTTON IS IN PLAYBACK STATUS, INDICATING THAT THE REPLAY OF THE SESSION CAN BE WATCHED",
    "page27": "SESSION INCLUDE VSS, BOOKMARK, PRODUCT PUSH, CLARITY, VOLUME, ETC.",
    "page28": "RETURN TO SESSION LIST",
    "page29": "PLAZA IS INCLUDES PRE-HEAT AND VIDEO SMART SEARCH",
    "page30": "PRE-HEAT",
    "page31": "SESSION PRE-HEAT IMAGE AND VIDEO",
    "page32": "VIDEO SMART SEARCH",
    "page33": "ENTER CONTENT, SELECT SESSION, CLICK SEARCH",
    "page34": "DISPLAY OF SEARCH RESULTS",
    "page35": "PRODUCT ASSET LIBRARY",
    "page36": "PAL INCLUDE HOMEPAGE AND TOTAL LOOK",
    "page37": "SEARCH AND FILTER PRODUCTS",
    "page38": "VIEW PRODUCT DETAILS",
    "page39": "PRODUCT DETAILS",
    "page40": "COLLECT",
    "page41": "COLLECT PRODUCTS TO FAVORITES",
    "page42": "SELECT FAVORITES",
    "page43": "RECORD PRODUCT NOTES",
    "page44": "RECORD AND SUBMIT",
    "page45": "NOTE LIST",
    "page46": "NOTE EXPORT",
    "page47": "RETURN TO THE ANNOUNCEMENT AND VIEW THE NOTE EXPORT FILE",
    "page48": "TOTAL LOOK",
    "page49": "PURCHASE RECOMMENDATION CLASSIFICATION",
    "page50": "VIEW TOTAL LOOK",
    "page51": "SWITCH LEFT AND RIGHT TO VIEW TOTAL LOOK",
    "page52": "SWITCH PRODUCT DETAILS",
    "page53": "VIEW PRODUCT DETAILS"
  },
  preferences_setting:{
    MENS: "MENS",
    WOMENS: "WOMENS",
    KIDS: "KIDS",
    FOOTWEAR:"FOOTWEAR",
    APPAREL: "APPAREL",
    EQUIPMENT: "EQUIPMENT",
    PERFORMANCE: "PERFORMANCE",
    LIFESTYLE: "LIFESTYLE",
    JORDAN: "JORDAN",
    tips:"PLEASE SELECT AT LEAST ONE ITEMS OF INTEREST",
    err_message: "PLEASE SELECT AT LEAST ONE",
    OTHERS:"OTHERS",
    tip_err_1:"SELECT AT LEAST ONE GENDER OF INTEREST",
    tip_err_2:"SELECT AT LEAST ONE CATEGORY OF INTEREST",
    tip_err_3:"SELECT AT LEAST ONE PLANNING INTENDED USE OF INTEREST",
  },
  error: "ERROR",
  application:{
    "产品库": "BY-SESSION PRODUCT HIGHLIGHT"
  },
  'Q&A':'Q&A',
  "forecast_of_assets": "PRE-HEAT ASSET",
  chatroom:'CHATROOM',
  sports_events: "SPORTS EVENTS",
  announcement_board: "ANNOUNCEMENT BOARD",
  floor: "FLOOR",
  loading: "LOADING",
  announcement_type:{
    in_station: 'SYSTEM ANNOUNCEMENT',
    active: "EVENT ANNOUNCEMENT",
    session: "SESSION ANNOUNCEMENT",
    sport: "SPORT ANNOUNCEMENT",
    activity: "ACTIVITY ANNOUNCEMENT"
  },
  score:{
    score:'INTEGRAL',
    score_detail:'INTEGRAL DETAILS',
    score_rules:'INTEGRAL RULES',
    sign_in:'SIGN IN',
    signed:'CHECKED'
  },
  VSS:"VIDEO SMART SEARCH",
  step:"STEP",
  vss:{
    input_video_tag:'INPUT VIDEO TAG',
    select_session:'SELECT SESSION',
    new_feature:'NEW FEATURE',
    tip1:'STEP 1',
    tip2:'STEP 2',
    description1:'The square added the Video Smart Search feature.',
    description2:'You can search by video tag and meeting, please select a tag, meeting to search. The label is enterable, type it and enter to confirm the label.',
    description3:'The search results are highlighted, and clicking on the results will redirect you to the page.',
    warning1:'PLEASE SELECT A MEETING.',
    warning2:'PLEASE SELECT A MEETING AND SEARCH.',
    warning3:'PLEASE SELECT TAGS'
  },
  nextBtnText: "NEXT",
  prevBtnText: "PREV",
  doneBtnText: "DONE",
  closeBtnText: "SKIP",
  select_all:'SELECT ALL',
  cancel_select:'CANCEL SELECT',
  score_item_map:{
    "0":"SIGN IN",
    "1":"BUILDING AND MEETING SIGN IN",
    "2":"WATCH LIVE SESSION",
    "3":"WATCH PREVIEW OR REPLAY",
    "4":"CHATROOM",
    "5":"BOOKMARK",
    "6":"VIEW RECOMMENDED PRODUCT",
    "7":"THUMB UP",
    "8":"USE NOTE",
    "9":"COLLECTION",
    "10":"SPORT SIGN IN",
  },
  time: 'TIME',
  //错误信息
  errMsg: {
    "validation error": "VALIDATION ERROR!",
    email_no_match_phone: "THE EMAIL DOES NOT MATCH THE MOBILE PHONE NUMBER!",
    phone_no_match_email: "THE PHONE NUMBER DOES NOT MATCH THE EMAIL!",
    register_confirm_privacy: "IF YOU WANT TO SIGN UP TO THIS EVENT, PLEASE CHECK AND AGREE NIKE'S PRIVACY.",
    user_not_exist: "USER NOT EXIST",
    login_confirm_privacy: "IF YOU WANT TO LOG IN THE EMOMENT, PLEASE CHECK AND AGREE NIKE'S PRIVACY.",
    "password error":"PASSWORD ERROR",
    "BAD PASSWORD FORMAT": "BAD PASSWORD FORMAT.",
    "TWO DIFFERENT PASSWORDS": "TWO DIFFERENT PASSWORDS.",
    "NAME IS REQUIRED": "NAME IS REQUIRED.",
    "PASSWORD IS REQUIRED": "PASSWORD IS REQUIRED.",
    "PHONE NUMBER AND EMAIL CAN'T BE EMPTY AT THE SAME TIME": "PHONE NUMBER AND EMAIL CAN'T BE EMPTY AT THE SAME TIME.",
    "ACCOUNT GROUP IS REQUIRED": "ACCOUNT GROUP IS REQUIRED",
    "GENDER IS REQUIRED": "GENDER GROUP IS REQUIRED",
    "CHOOSE ONE OF ONLINE AND ONSITE AT LEAST.": "CHOOSE ONE OF ONLINE AND ONSITE AT LEAST.",
    OKTA_Login_Fail: "OKTA LOGIN FAILED, PLEASE TRY TO CLICK \"NIKE INTERNAL LOGIN\" TO LOGIN AGAIN.",
    "MSG CANNOT BE EMPTY": "MSG CAN'T BE EMPTY.",
    "QUESTION CANNOT BE EMPTY": "QUESTION CANNOT BE EMPTY.",
    "PROBLEM FEEDBACK FAILED": "PROBLEM FEEDBACK FAILED",
    "notice expired": "NOTICE EXPIRED.",
    "you have no permission": "YOU HAVE NO PERMISSION TO LOGIN TO SYSTEM!",
    "no_phone": "PHONE NUMBER CAN'T BE EMPTY.",
    "no_validation_code": "VALIDATION CODE CAN'T BE EMPTY.",
    "same_phone": "THE NEW PHONE NUMBER IS THE SAME AS THE OLD PHONE NUMBER, DO NOT NEET TO BE UPDATED.",
    "phone number existed": "THE PHONE NUMBER IS EXISTED, PLEASE TRY OTHER PHONE NUMBER.",
    "email existed": "EMAIL IS EXISTED, PLEASE TRY OTHER EMAIL.",
    "no_username": "USERNAME CANT'T BE EMPTY!",
    "no_email": "EMAIL CAN'T BE EMPTY!",
    "no_company": "COMPANY CAN'T BE EMPTY!",
    "incorrect email format": "INCORRECT EMAIL FORMAT.",
    "same_email": "NEW EMAIL IS THE SAME AS OLD EMAIL.",
    "wrong validation code, please check it again.": "WRONG VALIDATION CODE, PLEASE CHECK IT AGAIN.",
    "invitation code is expired or reach allowed max user": "INVITATION CODE IS EXPIRED OR REACH ALLOWED MAX USER.",
    "invitation code is reach allowed max user": "INVITATION CODE IS REACH ALLOWED MAX USER",
    "owner has completed request, not allow approve item again": "EVENT ADMIN HAS ALREADY APPROVED THIS REQUEST, YOU CANNOT APPROVE THIS REQUEST AGAIN.",
    "no attendee need to approve": "NO ATTENDEE NEED TO BE APPROVED.",
    "unable find invitation code": "INVALID INVITATION CODE.",
    "invitation code is expired": "INVITATION CODE IS EXPIRED.",
    "request in progress": "YOUR REQUEST IS IN PROGRESS.",
    "request approved in this event": "YOUR REQUEST HAS BEEN APPROVED.",
    "login fail": "LOGIN FAILED",
    "user blocked": "YOUR ACCOUNT HAS BEEN DEACTIVATED.",
    "PHONE NUMBER AND EMAIL REQUIRED": "PHONE NUMBER AND EMAIL ARE ALL REQUIRED.",
    "user have no email": "YOU DO NOT HAVE EMAIL ADDRESS.",
    "no access to login system": "NO ACCESS TO LOGIN SYSTEM.",
    "the image you uploaded is not in the right format": "THE IMAGE YOU UPLOADED IS NOT IN THE RIGHT FORMAT, THE IMAGE ONLY SUPPORTS: JPG, PNG, JPEG FORMAT!",
    "some bookmark not save": "UNSAVED CONTENT!",
    'you have already approved to join this event, no need to request': 'you have already approved to join this event, no need to request',
    "no users ro no sessions in this invitation": "NO USERS OR NO SESSIONS IN THIS INVITATION",
    "no chat history":"NO CHAT HISTORY",
    "you are not authorized as an broadcaster": "YOU ARE NOT AUTHORIZED AS AN BROADCASTER",
    "chat message send error": "MESSAGE SENDING FAILED, PLEASE TRY AGAIN LATER",
  },
  //成功提醒
  successMsg: {
    "copy successfully": "COPY SUCCESSFULLY.",
    change_password_success: "CHANGE PASSWORD SUCCESSFULLY!",
    password_reset_succeeded: "PASSWORD RESET SUCCEEDED!",
    "send_email_validation_same_time": "IF YOU CANNOT RECEIVE VALIDATION CODE THROUGH SMS, SYSTEM HAS ALREADY SENT VALIDATION CODE THROUGH EMAIL, PLEASE CHECK YOUR EMAIL INBOX TO FIND VALIDATION CODE!",
    "send_email_validation_success": "THE VERIFICATION CODE HAS BEEN SENT TO YOUR EMAIL ADDRESS, PLEASE CHECK IT!",
    "send_phone_validation_success": "THE VERIFICATION CODE HAS BEEN SENT TO YOUR PHONE, PLEASE CHECK IT!",
    "the_reservation_email_has_been_sent": "THE RESERVATION EMAIL HAS BEEN SENT!"
  },
  //提示信息
  confirmMsg: {
    "confirm delete bookmark": "CONFIRM TO DELETE BOOKMARK?",
    no_event: 'YOU HAVE NO EVENT YET.',
    no_other_event: "YOU HAVE NO EVENT YET.",
    no_session: 'YOU HAVE NO SESSION YET.',
    no_notice: "YOU HAVE NO ANNOUNCEMENT YET",
    preparatory_phase: "THE EVENT IS IN THE PREPARATORY STAGE",
    event_not_start: "THE EVENT HAS NOT ENTERED BEGIN STATE, PLEASE WAIT!"
  },
// 警告提示
warningMsg:{
  'no_wonderful_moment_content': 'NO WONDERFUL MOMENT CONTENT ~'
},
  preview: "PREVIEW",
  notice: "ANNOUNCEMENT",
  view_detail: "VIEW DETAIL",
  notice_detail: {
    all: "ALL",
    in_station: "SYSTEM",
    active: "EVENT",
    session: "SESSION",
    sport: "SPORT",
    activity:"ACTIVITY",
    unread: "UNREAD",
    all_read: "ALL HAVE BEEN READ",
    view: "view",
    accessory: "ACCESSORY",
    accessory_name: "ACCESSORY NAME",
    notice_name: "ANNOUNCEMENT NAME",
    download_accessory: "DOWNLOAD ACCESSORY",
    new_notice: "NEW ANNOUNCEMENT"
  },
  broadcast: {
    start_at: "BROADCAST WILL START AT {start_time}",
    start: "START BROADCAST",
    thanks_for_watching: "THANKS FOR WATCHING!",
    start_time: "START TIME: {start_time}",
    will_go: "JUMP TO NEXT SESSION IN <span class='second'>{seconds}</span> SECONDE(S).",
    stop_go_btn: "DO NOT JUMP",
  },

  app: {
    broswer: "BROWSER DOES NOT SUPPORT!",
    broswer0: "THE COMPATIBILITY OF THE CURRENT BROWSER IS POOR, PLEASE USE ",
    broswer1: "Chrome",
  },

  login: {
    phone_number: "PHONE NUMBER",
    enter_phone_number: "PLEASE ENTER PHONE NUMBER",
    enter_email_number: "PLEASE ENTER EMAIL",
    send_validation_code: "GET VALIDATION CODE",
    enter_validation_code: "PLEASE ENTER VALIDATION CODE",
    count_down_validation: "TRY AGAIN AFTER {second} SECOND(S)",
    login: "LOGIN",
    register: "SIGN UP",
    privacy: "I AGREE TO NIKE'S <a class='privacy_link' style='{style}' href='/Privacy' target='_blank'>PRIVACY POLICY</a>",
    language: "LANGUAGE",
    nike_login: "NIKE INTERNAL LOGIN",
    nike_register: "NIKE INTERNAL SIGN UP",
    back_login: "BACK TO LOGIN",
    pwd_tip: "IF YOU HAVE NOT RECEIVED THE VERIFICATION CODE, PLEASE CONTACT EMOMENT.SERVICE@NIKE.COM",
    new_pwd: "PLEASE ENTER NEW PASSWORD",
    confirm_new_pwd: "PLEASE CONFIRM THE NEW PASSWORD"
  },

  no_resources: "NO RESOURCES",

  register: {
    division: "DIVISION",
    category: "CATEGORY",
    gender: "GENDER",
    tag1: "TAG",
    tag2: "CATEGORY",
    tag3: "GENDER",
    tag4: "TAG4",
    tag5: "TAG5",
    user_tag:'TAG',
    confirm_user_information: "CONFIRM USER INFORMATION",
    password: "PASSWORD",
    confirm_password: "CONFIRM PASSWORD",
    old_password: "PLEASE ENTER OLD PASSWORD",
    new_password: "PLEASE ENTER NEW PASSWORD",
    name: "NAME",
    gender: "GENDER",
    select_gender: "SELECT GENDER",
    male: "MALE",
    female: "FEMALE",
    phone: "PHONE NUMBER",
    old_phone: "OLD PHONE NUMBER",
    new_phone: "NEW PHONE NUMBER",
    old_email: "OLD EMAIL",
    new_email: "NEW EMAIL",
    validation_code: "VALIDATION CODE",
    pwd_placeholder: "PASSWORDS MUST CONTAIN UPPERCASE AND LOWERCASE LETTERS AND NUMBERS WITH AT LEAST 8 DIGITS",
    get_validataion_code: "GET CODE",
    email: "EMAIL",
    change: "CHANGE",
    upload_avatar: "UPLOAD AVATAR",
    account_group: "ACCOUNT GROUP",
    select_account_group: "SELECT ACCOUNT GROUP",
    area: "LOCATION",
    city: "CITY",
    company: "COMPANY",
    online: "ONLINE",
    onsite: "ONSITE",
    online_onsite_description: "SUPPORTING MULTIPLE SELECTION. BUT PLEASE CHOOSE ONLINE/ONSITE ACCORDING TO YOUR ACTUAL SITUATION.",
    language: "LANGUAGE",
    select_language: "SELECT LANGUAGE",
    register: "SIGN UP",
    privacy: "I AGREE TO NIKE'S <a class='privacy_link' href='/Privacy' target='_blank'>PRIVACY POLICY</a>",
    reg_pending_name: "DEAR {user_name}, ",
    reg_pending: "YOU HAVE ALREADY REQUESTED TO JOIN EVENT [{event_name}], PLEASE WAIT FOR PARTNER CONTACT / EVENT ADMIN APPROVAL.",
    input_name: "INPUT NAME",
    input_phone: "PHONE NUMBER",
    input_email: "INPUT EMAIL",
    select_company: "SELECT COMPANY",
    input_location: "INPUT LOCATION",
    input_city: "INPUT CITY",
    select_divistion: "SELECT DIVISTION",
    select_category: "SELECT CATEGORY",
    select_tag_gender: "SELECT GENDER",
    warning: "WARNING",
    retry_warning: "SYSTEM FOUND THAT YOU HAVE ALREADY SENT VALIDATION CODE FOR SERVERAL TIMES. IF YOU STILL HAVE NOT RECEIVED VALIDATION CODE, PLEASE SEND YOUR NAME, PHONE NUMBER, PHONE PREFIX (+86, +886, +852, +853) AND EMAIL TO US THROUGH EMAIL (EMAIL ADDRESS: <a href='mailto:eMoment.Service@nike.com'>eMoment.Service@nike.com</a>). SYSTEM WILL CREATE ACCOUNT, AND YOU WILL RECEIVE EMAIL REMINDER. PLEASE TRY TO LOGIN / REGISTER TO SYSTEM, AFTER RECEIVING REMINDER.",
  },

  update_me: {
    get_code: "GET CODE",
    count_down: "TRY AGAIN, AFTER {second}S",
  },

  litter_helper: {
    eMoment_litter_helper: "eMoment HELP DESK",
    user_manual: "USER MANUAL",
    feature_description_video: "FEATURE DESCRIPTION VIDEO",
    FAQ: "FAQ",
    catalog: "CATALOG",
    clear_the_history: "CLEAR THE HISTORY",
    history: "HISTORY",
    search_placeholder: "PLEASE ENTER A KEYWORD SEARCH",
    no_content: "NO CONTENT",
    no_search: "SORRY, NO RESULTS. PLEASE TRY A DIFFERENT KEYWORD~",
    preparatory_phase: "PREPARATORY STAGE",
    registration_phase: "REGISTRATION STAGE",
    activity_phase: "EVENT BEGIN STAGE",
    activity_end: "EVENT END STAGE",
    solve_problem: "WHETHER IT SOLVES YOUR PROBLEM ?",
    solve_problem_ok: "YES",
    solve_problem_no: "NO",
    feedback: "THANK YOU FOR YOUR FEEDBACK !",
    send_email: "PLEASE EDIT YOUR QUESTIONS AND SEND THEM TO",
    i_know: "I SEE",
    system_admin: "SYSTEM ADMIN",
    event_admin: "EVENT ADMIN",
    attendee: "ATTENDEE",
    broadcaster: "BROADCASTER",
    partner_contactor: "PARTNER CONTACT",
    speaker: "SPEAKER",
    assistant: "SPECIALIST",
    general: "GENERAL",
    close_inquiry: "CLOSED AFTER {count}s",
    faq_feedback: "FEEDBACK",
    enter_question: "PLEASE ENTER A QUESTION",
    successful_problem_feedback: "SUCCESSFUL PROBLEM FEEDBACK"
  },

  activity: {
    no_content: "NO ACTIVITY INTRODUCTION AT PRESENT"
  },

  privacy: "PRIVACY",
  system_admin: "SETTINGS",

  session: {
    get_obs: "GET OBS SOFTWARE",
    obs_studio: "OBS STUDIO",
    vlc_playper: "VLC PLAYER",
    obs_studio_subtitle: "OBS STUDIO SUBTITLE PLUGIN",
    download: "DOWNLOAD",
    get_obs_start: "GET OBS STARTER FOR THIS CHANNEL",
    current_channel: "CURRENT CHANNEL",
    broadcast_date: "BROADCAST DATE: ",
    broadcast_time: "BROADCAST TIME: ",
    broadcast_start: "STARTED",
    join_in_chat_room: "JOIN IN CHATROOM",
    back_to_event: "BACK TO EVENT",
    back_to_role_select: "BACK TO ROLE SELECT",
    session_name: "NAME",
    session_time: "TIME",
    session_type: "TYPE",
    session_date: "DATE",
    session_room_name: "SESSION ROOM",
    session_place: 'PLACE',
    session_room: 'ROOM',
    estimated_video_duration: "ESTIMATED VIDEO DURATION",
    video_duration: "VIDEO DURATION",
    session_detail: "SESSION DETAIL",
    speaker: "SPEAKER",
    session_description: "DESCRIPTION",
    activity_introduction: "ACTIVITY INTRODUCTION",
    activity_session: "ACTIVITY SESSION (OFFLINE)",
    video_time: "VIDEO TIME",
    month: "MONTH",
    day: "DAY",
    hour: "HOUR",
    minute: "MINUTE",
    second: "SECOND",
    chat_in_room: "CHAT IN {session_name}",
    input_chat_msg: "INPUT MSG",
    chat_room: "CHAT ROOM",
    send: "SEND",
    home: "EVENT LIST",
    logout: "LOGOUT",
    save: "SAVE",
    cancel: "CANCEL",
    notice: "NOTICE",
    no_event: "YOU HAVE NO EVENT NOW.",
    no_session: "YOU HAVE NO SESSION NOW.",
    player_error: "BROADCAST ERROR, PLEASE REFRESH LATER. IF THE PROBLEM IS STILL EXISTED, PLEASE CONTACT WITH SYSTEM ADMIN.",
    liveStreamStop: "THE CURRENT SESSION HAS ENDED",
    chapter: 'CHAPTER',
    bookmark: 'BOOKMARK',
    bookmark_input: 'PLEASE ENTER THE CONTENT',
    no_bookmark: 'NO BOOKMARK',
    window_title: 'WINDOW',
    chatroom: 'CHATROOM',
    attendee_list: 'ATTENDEE LIST',
    online: 'ONLINE',
    offline: 'OFFLINE',
    select: 'SELECT...',
    to_all: 'ALL',
    delete_message: "CONFIRM THE DELETION OF THE MESSAGE?",
    status: 'STATUS',
    block: 'SILENCE',
    block_reason: 'REASON FOR SILENCE:',
    send_to_you: 'PRIVATE CHAT',
    you_send_to: 'PRIVATE CHAT',
    say: ' ',
    blocking: 'SILENCE',
    block_count_down: 'SILENCE COUNTDOWN:',
    someone_send_me: 'I WAS CHATTED PRIVATELY.',
    download_chat: 'DOWNLOAD CHAT RECORD',
    download_after_session: 'DOWNLOAD AFTER SESSION',
    send_to: 'SEND TO',
    okText: 'OK',
    cancelText: 'CANCEL',
    bookmark_tip: "BOOKMARK: CLICK BOX,TAKE NOTES.",
    caption_tip: "SUBTITLE: CLICK HERE,SHOW SUBTITLE.",
    thumbsUp_tip: "CLICK TO INTERACT WITH ONLINE ATTENDEES.",
    QA: {
      enter_QA: 'GO TO Q&A',
      preTitle: ' BRA/LEGGING EXPLANATION',
      is_mine: 'ONLY MY QUESTION',
      show_all_question: 'SHOW ALL QUESTION',
      all_qa: 'ALL QA',
      un_answer: 'NOT ANSWER',
      answered: 'ANSWERED',
      closed: 'UNCLOSED',
      my_question: 'MY QUESTIONS',
      all_question: 'ALL QUESTIONS',
      search_question: 'SEARCH',
      is_public: 'IS PUBLIC',
      input_notify: 'Please enter your question',
      text1: 'Welcome to Q&A.',
      text2: 'Your questions will be displayed here.',
      text3: "In addition to private messages, the questions you send will be displayed in the 'All Questions' list.",
      confirmDel: 'IDENTIFY DELETION ISSUES ？',
      confirmDelete: 'IDENTIFY DELETION？',
      confirmSend: 'SUBMIT OR NOT ？',
      confirmCancel: 'CANCEL OR NOT？(WILL DELETE THE INPUT) ？',
      myReAsk: 'I WANT TO ASK AGAIN...',
      reAsk: 'ASK AGAIN',
      myAsk: 'I WANT TO ASK...',
      inputAnswer: 'ENTER ANSWER...',
      answerNotify: 'CONFIRM ANSWER？',
      tips: 'TIPS',
      cancelIdentify: 'CANCEL CONFIRMATION (THE INPUT CONTENT WILL BE DELETED)',
      cancel: 'CANCEL',
      identify: 'COMMIT',
      modifyQAIdentify: 'CONFIRM MODIFYING THIS ISSUE?',
      commit: 'COMMIT',
      contentNotify: 'CONTENT CANNOT BE EMPTY.',
      total: 'total:',
      total1: ' ',
      noSession: 'SESSION NOT BOUND. PLEASE CONTACT THE EVENT ADMIN',
      edit: 'EDIT',
      answer: 'ANSWER',
      editQuestion: 'EDIT QUESTION',
      isPublic: 'IS PUBLIC',
      del: 'DELETE',
      me: 'ME',
      assistant: 'SPECIALIST',
      last_edit: 'LAST EDIT HAD UNSENT CONTENT,',
      use_last_edit: 'USE THE LAST EDIT'
    }
  },

  video: {
    try_later: "VIDEO TRANSCODING, PLEASE TRY AGAIN LATER",
  },

  meeting: {
    warning: "WARNING",
    agree_user_info: "AGREE",
    disagree_user_info: "DISAGREE, BACK TO SESSION LIST",
    agree_rule: "DEAR USER, DUE TO THE NEED TO PROVIDE THE ONLINE MEETING FUNCTION, THE NAME DISPLAYED WHEN YOU PARTICIPATE IN THE ONLINE MEETING WILL BE PROVIDED TO ZOOM AND TRANSMITTED TO THE OVERSEAS SERVER. DO YOU AGREE?",
  },

  portal: {
    participant: "PARTICIPANT PORTAL",
    admin: "ADMIN PORTAL",
    partner_contact: "PARTNER CONTACT",
    attendee: "ATTENDEE",
    assistant: "SPECIALIST",
    broadcaster: "BROADCASTER",
    hoster: "HOSTER",
  },
  'CORE': 'CORE',
  'NONCORE': 'NON CORE',
  approval: {
    not_approved: 'PENDING',
    approved_pass: 'APPROVED PASS',
    approved_refuse: 'APPROVED REFUSE',
    first_approval_pass: 'FIRST APPROVAL PASSED',
    first_approval_refuse: 'FIRST APPROVAL REFUSED',
    second_approved_refuse: 'SECOND APPROVAL REFUSED',
    first_approval_pass_tip: 'FIRST APPROVAL PASSED.PLEASE WAITING FOR SECOND APPROVAL.',
    first_approval_refuse_tip: 'FIRST APPROVAL REFUSED，IF YOU HAVE ANY QUESTIOS, PLEASE CONTACT THE CUSTOMER LIAISON.',
    approved_refuse_tip: 'APPROVAL REFUSED.IF YOU HAVE ANY QUESTIOS, PLEASE CONTACT THE EVENT LIAISON.'
  },
  event_detail: {
    approval_list: "APPROVAL LIST",
    approval_report: "APPROVAL REPORT",
    seasonal_video: "SEASONAL VIDEO",
    seasonal_image: "SEASONAL IMAGE",
    my_event: "MY OTHER EVENTS",
    report: {
      pc_approval: "Partner Contact APPROVAL REPORT",
      register_table: "REGISTRATION",
      register_table_approved: "APPROVED",
      register_table_rejected: "REJECTED",
      register_table_wait: "PENDING",
      approve_table: "APPROVAL",
      approve_table_left: "REMAIN",
      ea_approval: "Event Admin APPROVAL REPORT",
      ea_table_approved: "APPROVED",
      ea_table_rejected: "REJECTED",
      ea_table_wait: "PENDING",
      real_time_login: "REAL TIME LOGIN",
      real_time_login_description: "LOGIN DATA IN 5 MINUTES FROM [{time}].",
      actual_login: "ACTUAL LOGGED IN",
      no_login: "NOT LOGGED IN",
    },
    channel_list: "CHANNEL LIST",
    download_approval_list: "DOWNLOAD APPROVAL LIST",
    upload_approval_list: "UPLOAD APPROVAL LIST",
    online_onsite: "ONLINE/ONSITE",
    online: "ONLINE",
    onsite: "ONSITE",
    registration_status: "REGISTRATION STATUS",
    confirmed_status: {
      PENDING: "PENDING",
      CONFIRMED: "CONFIRMED",
      REJECTED: "REJECTED",
    },
    approve: "APPROVE",
    reject: "REJECT",
    edit: "EDIT",
    invitation_list: "INVITATION LIST",
    expired_time: "INVITATION EXPIRED TIME",
    invitation_url: "INVITATION URL",
  },

  user: {
    phone: "PHONE",
    email: "EMAIL",
    LOCATION: "LOCATION",
    COMPANY: "COMPANY",
    account_group: "ACCOUNT GROUP",
    CITY: "CITY",
    account: "ACCOUNT",
    password: "PASSWORD",
    name: "NAME",
    clear_openid: "CLEAR OPENID",
    disabled: "DISABLED",
    enabled: "ENABLED",
    prefix: "PREFIX",
    gender: "GENDER",
    is_disabled: "IS DISABLED",
    is_internal: "INTENRAL",
    only_internal: "ONLY INTERNAL",
    without_internal: "WITHOUT INTERNAL",
    TAG1: "TAG1",
    TAG2: "TAG2",
    TAG3: "TAG3",
    TAG4: "TAG4",
    TAG5: "TAG5",
    is_main_owner: "EVENT OWNER",
    is_owner: "EVENT ADMIN",
    is_partner_contact: "PARTNER CONTACT",
  },

  play_only_once: "PLAY ONLY ONCE",
  no_replay_available: "NO PLAYBACK AVAILABLE",
  account_group: "ACCOUNT GROUP",
  action: "ACTION",
  back: "BACK",
  event_name: "EVENT NAME",
  event_range: "EVENT RANGE",
  no_support_mobile: "THE PORTAL DOES NOT SUPPORT MOBILE PHONES.",
  copy: "COPY",
  confirm: "CONFIRMED",
  "INVITATION URL IS INVALID.": "INVITATION URL IS INVALID.",
  "RELOAD TO WATCH BROADCAST.": "BROADCAST WILL START SOON, PLEASE WAIT FOR A MOMENT.",
  "RELOAD TO WATCH PLAYBACK.": "PLAYBACK WILL START SOON, PLEASE WAIT FOR A MOMENT.",
  "BROADCAST IS OVER.": "BROADCAST IS OVER.",
  "PLAYBACK IS OVER.": "PLAYBACK IS OVER.",
  count_down_no_content: "THERE IS NO CONTENT FOR THIS SESSION. PLEASE CONTACT SYSTEM/EVENT ADMIN",
  "post bookmark success": "BOOKMARK MARKED.",

  mobile: {
    event_list: 'MY EVENT',
    pass_card: 'QR CODE',
    my_home: 'ME',
    my_sport: 'SPORTS',
    session_list: 'SESSION LIST',
    refresh: 'REFRESH',
    logout: 'LOGOUT',
    pass_in_min: 'ADMISSION TO THE MEETING BEGINS AT {time}',
    permission_err: 'YOU DON\'T HAVE PERMISSION TO ATTEND LIVE MEETINGS AT THIS TIME',
    expire_time: "QRCODE EXPIRE TIME <br/>【{time}】<br/> PLEASE TAKE A SCREENSHOT FOR USE",
    lead_time_tips: 'ADMISSION TO THE MEETING BEGINS AT {time}',
  },

  sport: {
    not_begin:'EVENT BEGIN SOON',
    sort_order: 'SORT ORDER',
    sort_asc:'ASCENDING',
    sort_desc:'DESCENDING',
    image:'IMAGE',
    video:'VIDEO',
    chosen:'SELECTED',
    cancelChoose:'CANCEL SELECT',
    batchDownload:'BATCH DOWNLOAD',
    sportScore:'ACTIVITY EVALUATION',
    event_organize_well:'EVENT ORGANIZED NICE',
    event_content_well:'EVENT CONTENT NICE',
    environment_well:'ENVIRONMENT NICE',
    place_well:'VENUE NICE',
    input_tip1:'YOUR EVALUATION WILL MAKE US BETTER.',
    commit:'COMMIT',
    assets:{
      division: "DIVISION",
      omd: "上市日期",
      suggest_price: "建议零售价",
      category: "品类",
      page_acc: "图册页码",
      page_kids: "儿童图册页码",
    },
    no_more:'NO MORE~',
    register_progress:'REGISTRATION PROGRESS',
    item_introduce:'ACTIVITY INTRODUCE',
    tips:'TIPS',
    had_register:'REGISTERED',
    in_progress: 'IN PROGRESS',
    ended: 'ENDED',
    stop_register:'STOP REGISTERED',
    wonderful_moment:'WONDERFUL MOMENT',
    over_max:'FULLY STAFFED',
    register_now:'REGISTER NOW',
    tip2:'NOTE*: To cancel your registration, please go to Activity List - Cancel in My Activities',
    register:'REGISTER',
    cancel_identify:'CONFIRM CANCELLATION?',
    gotoDetail:'ENTER DETAIL',
    switch_sport:'RECENT SPORT',
    switch_session:'RECENT SESSION',
    start_soon:'START SOON',
    had_start:'STARTED'
  },
  fold:'FOLD',
  unfold:'UNFOLD',
  man:'MALE',
  women:'FEMALE',
  cancel:'CANCEL',
  commit:'COMMIT',
  new_user_helper:{
    main_page:"1.PLAZA IS INCLUDES SPORTS AND ANNOUNCEMENTS;\n" + "2.EVENT LIST;\n" + "3.PERSONAL CENTER;\n" + "4.EMOMENT HELP DESK.\n",
    event_detail:"1.PLAZA IS INCLUDES SPORTS、PRE-HEAT ASSET、 ANNOUNCEMENTS AND VSS;\n" + "2.SESSION LIST INCLUDES 8 TYPES OF MEETINGS;\n" + "3.PRODUCT ASSET LIBRARY.\n" + "4.(AE WILL EQUIP CORRESPONDING FUNCTIONS AND SESSIONS ACCORDING TO THE NEEDS OF THE EVENT)\n",
    vss_search:"1.FUNCTION TRAINING;\n" + "2.VSS SEARCH, CLICK ON SEARCH RESULTS TO REDIRECT TO THE CORRESPONDING VIDEO PAGE;\n" + "3.CONTINUE SEARCH OR WATCH VIDEO.\n",
    attend_session:"1.SESSION APP (VSS, CHAT ROOM, BOOKMARK, PRODUCT PUSH,ETC.)\n" + "2.VIDEO FUNCTIONS (SUBTITLES, BOOKMARKS, CLARITY, VOLUME, ETC.)\n",
    pal:"1.PRODUCT ASSET LIBRARY AND KEYLOOK；\n" + "2.NOTES, COLLECTIONS, HISTORY；\n" + "3.FILTER AND SEARCH；\n" + "4.PRODUCT LIST；\n" + "5.KEYLOOK LIST.\n",
    product_detail:"1.Product Details – Video；\n" + "2.Product Details – Images；\n" + "3.Product color code list；\n" + "4.Product collection, favorites, notes.\n"
  },
  relatedSession:"RELATED SESSION",
  relatedProduct:"FEATURED PRODUCTS",
  more_detail:"MORE >",
  ipad_notice:"If you are using an iPad that cannot open the product information library, you can try to turn off the \"Block pop-ups\" option in \"Settings - Safari - General\".",
  ipad_notice_title:"IPad USES PRODUCT LIBRARY ALERT"
}



// WEBPACK FOOTER //
// ./src/i18n/en-us.js